<div class="center-container">
<button mat-raised-button (click)="login()" color="primary">Login with Azure AD</button>
</div>